import { combineReducers } from '@reduxjs/toolkit';

/* PLOP_INJECT_IMPORT */
import { modalReducer } from './modal/modal.slice';
import { locationReducer } from './location/location.slice';
import { userReducer } from './user/user.slice';
import { orderReducer } from './order/order.slice';

const rootReducer = combineReducers({
  /* PLOP_INJECT_USE */
  modal: modalReducer,
  location: locationReducer,
  user: userReducer,
  order: orderReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
